// 로그인 상태 저장소 — 메모리에만 둔다. 어디서 받아 오고 어디에 보관할지는 auth 플러그인이 정한다 (ports/session.ts)
import { useSyncExternalStore } from 'react';

import type { Session, SessionStore } from '../ports/session';

export function createSessionStore(now: () => number = Date.now): SessionStore {
  let current: Session | null = null;
  const listeners = new Set<() => void>();
  return {
    get() {
      // 만료를 읽는 시점에 본다 — 같은 값을 계속 돌려줘야 useSyncExternalStore 가 다시 그리지 않는다
      if (current && current.expiresAt <= now()) current = null;
      return current;
    },
    set(session) {
      current = session;
      listeners.forEach(notify => notify());
    },
    subscribe(listener) {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
  };
}

/** 앱 하나에 로그인 상태 하나 */
export const sessionStore: SessionStore = createSessionStore();

/** 로그인돼 있으면 세션, 아니면 null. 로그인·로그아웃 때 다시 그린다 */
export function useSession(): Session | null {
  return useSyncExternalStore(sessionStore.subscribe, sessionStore.get, () => null);
}
